function debugMessage(message: string) {
  // eslint-disable-next-line no-console
  console.warn(message)
}

export default debugMessage
